import { fieldTypeConstants } from '@/utils/checklistutils/support_list'
export default {
  data () {
    return {
      fieldTypeConstants: fieldTypeConstants
    }
  }
}
